import { render, staticRenderFns } from "./ProfileChangeName.vue?vue&type=template&id=c564115e&scoped=true"
import script from "./ProfileChangeName.vue?vue&type=script&lang=js"
export * from "./ProfileChangeName.vue?vue&type=script&lang=js"
import style0 from "./ProfileChangeName.vue?vue&type=style&index=0&id=c564115e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c564115e",
  null
  
)

export default component.exports